import * as XLSX from 'xlsx';

export const BENEFICIARY_IMPORT_FILENAME = 'modelo_importacao_beneficiarios.xlsx';

export const BENEFICIARY_IMPORT_SECTOR_COLUMN = 'SETOR';

export const BENEFICIARY_IMPORT_COLUMNS = [
	'BENEFICIARIO',
	'EMAIL',
	'CPF',
	'DT_NASCIMENTO',
	'SEXO',
	'DDD',
	'Telefone',
	'PLANO',
	BENEFICIARY_IMPORT_SECTOR_COLUMN,
];

const BENEFICIARY_IMPORT_INSTRUCTIONS = [
	'nome completo',
	'nome@email.email',
	'sem "." ou "-"',
	'dd/mm/aaaa',
	'Masculino/Feminino/prefiro não informar',
	21,
	'XXXXXXXXX',
	'_NOME DO PLANO',
	'nome do setor já cadastrado (opcional)',
];

const BENEFICIARY_IMPORT_COLUMN_WIDTHS = [30, 30, 20, 18, 40, 8, 14, 25, 40];

// Linha real no Excel: índice base 0 + cabeçalho (1) + 1.
export const toExcelRow = (index) => index + 2;

export const buildBeneficiaryImportTemplate = () => {
	const worksheet = XLSX.utils.aoa_to_sheet([BENEFICIARY_IMPORT_COLUMNS, BENEFICIARY_IMPORT_INSTRUCTIONS]);
	worksheet['!cols'] = BENEFICIARY_IMPORT_COLUMN_WIDTHS.map((wch) => ({ wch }));

	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Beneficiarios');
	return workbook;
};

export const downloadBeneficiaryImportTemplate = () =>
	XLSX.writeFile(buildBeneficiaryImportTemplate(), BENEFICIARY_IMPORT_FILENAME);
